import Immutable from 'seamless-immutable'
import types from '../../../actions/types'
import { createPivotTableReducer } from '../../../reducers/pivotTable'
import { combineReducers } from 'redux'

const showDormants = (state = Immutable(false), action) => {
  switch (action.type) {
    case types.CONTACTGRID_UPDATE_FILTERS:
      return (action.filters.hasOwnProperty('showDormants'))
        ? action.filters.showDormants
        : state
    default:
      return state
  }
}

export const contactsContextGridPivotTableKey = 'contactsContext.grid.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({key: contactsContextGridPivotTableKey, defaultSortColumn: 'startDate', defaultSortDirection: 'desc', pageSize: 50}),
  showDormants,
})
